module.exports = __webpack_public_path__ + "assets/img/m_healthVIP.34174c70.png";